import {
    SERVICES_FIELD_CHANGED,
    FETCH_SERVICES,
    FETCH_SERVICES_FAILED,
    FETCH_SERVICES_SUCCESSFUL,
    FETCH_ACTIVITY_ACTIVISTS,
    FETCH_ACTIVITY_ACTIVISTS_FAILED,
    FETCH_ACTIVITY_ACTIVISTS_SUCCESSFUL,
    FETCH_MORE_SERVICES,
    FETCH_MORE_SERVICES_FAILED,
    FETCH_MORE_SERVICES_SUCCESSFUL,
    HIDE_NEW_ACTIVITY_MODAL,
    PUSH_SERVICE_REQUEST,
    SHOW_NEW_ACTIVITY_MODAL,
    DELETE_SERVICE_REQUEST,
    DELETE_SERVICE_REQUEST_SUCCESSFUL,
    DELETE_SERVICE_REQUEST_FAILED,
    RESOLVE_SERVICE_REQUEST,
    RESOLVE_SERVICE_REQUEST_SUCCESSFUL,
    RESOLVE_SERVICE_REQUEST_FAILED,
    FETCH_LEGAL_SERVICES_SUCCESSFUL,
} from "../actions/Types";

const INITIAL_STATE = {
    startAt: 20,
    services: [],
    servicesLoading: false,
    moreServicesLoading: false,

    service: {},

    enquiryFilter: "",

    showNewActivityModal: false,

    generalNotification: "",
    groupNotification: "",

    deleteRequestLoading: false,
    resolveRequestLoading: false,
    legalServices: []
};

const servicesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        //change reducers
        case SERVICES_FIELD_CHANGED:
            return { ...state, [action.payload.prop]: action.payload.value };


            //fetch reducers
        case FETCH_SERVICES:
            return { ...state, servicesLoading: true };
        case FETCH_SERVICES_SUCCESSFUL:
            return { ...state, services: action.payload.services, startAt: action.payload.startAt, servicesLoading: false };
        case FETCH_SERVICES_FAILED:
            return { ...state, servicesLoading: false };

        case FETCH_MORE_SERVICES:
            return { ...state, moreServicesLoading: true };
        case FETCH_MORE_SERVICES_SUCCESSFUL:
            return { ...state, services: action.payload.services, startAt: action.payload.startAt, moreServicesLoading: false }
        case FETCH_MORE_SERVICES_FAILED:
            return { ...state, moreServicesLoading: false };

            //modal reducer
        case SHOW_NEW_ACTIVITY_MODAL:
            return { ...state, showNewActivityModal: true };
        case HIDE_NEW_ACTIVITY_MODAL:
            return { ...state, showNewActivityModal: false };

            //push
        case PUSH_SERVICE_REQUEST:
            return { ...state, service: action.payload };


        case DELETE_SERVICE_REQUEST:
            return { ...state, deleteRequestLoading: true };
        case DELETE_SERVICE_REQUEST_SUCCESSFUL:
            return { ...state, deleteRequestLoading: false };
        case DELETE_SERVICE_REQUEST_FAILED:
            return { ...state, deleteRequestLoading: false };

        case RESOLVE_SERVICE_REQUEST:
            return { ...state, resolveRequestLoading: true };
        case RESOLVE_SERVICE_REQUEST_SUCCESSFUL:
            return { ...state, resolveRequestLoading: false };
        case RESOLVE_SERVICE_REQUEST_FAILED:
            return { ...state, resolveRequestLoading: false };

        case FETCH_LEGAL_SERVICES_SUCCESSFUL:
            return { ...state, legalServices: action.payload };

        default:
            return state;
    }
};

export default servicesReducer;